import React from 'react';
import { Button, Row, Col, message } from 'antd';
import NHModal from "../NHModal/index";
import EditPage from "./edit-page";
import NHInputRender from './render';
import PropTypes from "prop-types";
// import {NHModal} from 'xgui-for-react'

/**
 * 输入控件配置生成器
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-02-05 13:57:05
 * Version: 1.0
 * Modify log:
 */
class NHInputPicker extends React.Component {

    constructor(props) {
        super(props);
        const value = this.props.value || '';
        this.state = {
            feature: value || '' //设置的输入控件配置参数
        }
    }

    componentWillReceiveProps(nextProps) {
        // Should be a controlled component.
        if ('value' in nextProps) {
            const value = nextProps.value;
            this.setState({ feature: value });
        }
    }

    //供父组件获取feature
    getFeature = () => {
        return this.state.feature;
    }

    //打开输入控件配置窗口
    handleBtnClick = () => {
        this.nhModal.show();
    }

    handleOk = (stopLoading) => {
        let feature = this.editpage.getFeature();
        let map = JSON.parse(feature);
        if(map.type==="upload"){
            if(map.moduleName&&map.serviceMark){
                if (feature === undefined) {
                    message.warning("未设置任何输入控件配置信息！");
                } else {
                    if (!('value' in this.props)) {
                        this.setState({ feature: feature });
                    }
                    this.triggerChange(feature);
                }
                this.nhModal.close();
            }else{
                message.error("服务标志和模块名称不能为空！")
                stopLoading();
            }
        }else{
            if (feature === undefined) {
                message.warning("未设置任何输入控件配置信息！");
            } else {
                if (!('value' in this.props)) {
                    this.setState({ feature: feature });
                }
                this.triggerChange(feature);
            }
            this.nhModal.close();
        }
    }

    triggerChange = (changedValue) => {
        // Should provide an event to pass value to Form.
        const onChange = this.props.onChange;
        if (onChange) {
            onChange(changedValue);
        }
    }

    render() {
        return (
            <div>
                <Row>
                    <Col>
                        {
                            this.state.feature ? <NHInputRender feature={this.state.feature} isEdit={this.props.isEdit}/> :
                                (
                                    this.props.value ? <NHInputRender feature={this.props.value} isEdit={this.props.isEdit}/> : null
                                )
                        }
                    </Col>
                    <Col>
                        <Button onClick={this.handleBtnClick}>设置输入框类型</Button>
                    </Col>
                </Row>
                <NHModal
                    ref={(form) => { this.nhModal = form }}
                    title="设置输入控件类型"
                    width={620}
                    onOk={this.handleOk}
                >
                    <EditPage ref={(form) => { this.editpage = form }}
                        initFeature={this.state.feature ? this.state.feature : this.props.initFeature}>
                    </EditPage>
                </NHModal>
            </div>
        )
    }
}

/**
 * @type {{value: *, onChange: *}}
 */
NHInputPicker.propTypes = {
    value: PropTypes.string, //输入控件参数字符串
    onChange: PropTypes.func //输入控件参数变化时的回调方法
}

export default NHInputPicker;



// WEBPACK FOOTER //
// ./components/common/NHInputPicker/index.js